import { useEffect } from 'react';
const SITE_TITLE = 'Wishing Tree Events | Dream. Wish. Celebrate.';
const SITE_DESCRIPTION = "Every celebration starts with a little wish. Choose the experience that feels right for your celebration, and we'll take care of the magic.";
const SITE_IMAGE = "/Dream._Wish._Celebrate.-3.jpg";
function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
export function useSiteMetadata() {
  useEffect(() => {
    document.title = SITE_TITLE;
    setMeta('name', 'description', SITE_DESCRIPTION);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Wishing Tree Events');
    setMeta('property', 'og:title', SITE_TITLE);
    setMeta('property', 'og:description', SITE_DESCRIPTION);
    setMeta('property', 'og:image', SITE_IMAGE);
    setMeta('property', 'og:url', window.location.origin);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SITE_TITLE);
    setMeta('name', 'twitter:description', SITE_DESCRIPTION);
    setMeta('name', 'twitter:image', SITE_IMAGE);
  }, []);
}